import React from 'react';
import PropTypes from 'prop-types';
import CompletedGameCard from './CompletedGameCard';
import InProgressGameCard from './InProgressGameCard';
import ScheduledGameCard from './ScheduledGameCard';

const GameCard = React.memo(({ game, userPick, displayedWeek, watchedPicks, isBetSlipOpen, className, ...props }) => {
  // Add className to the props being passed down
  const combinedProps = {
    ...props,
    className,
    game,
    userPick,
    displayedWeek,
    watchedPicks,
    isBetSlipOpen
  };

  // Route to the appropriate component based on game status
  switch (game.game_status) {
    case 'completed':
      return <CompletedGameCard {...combinedProps} />;
    case 'in_progress':
      return <InProgressGameCard {...combinedProps} />;
    default: // 'scheduled' or any other status
      return <ScheduledGameCard {...combinedProps} />;
  }
}, (prevProps, nextProps) => {
  // First check if either game object is null/undefined
  if (!prevProps.game || !nextProps.game) return false;

  // Check all relevant game properties that could change during live updates
  const gameChanged = 
    prevProps.game.id !== nextProps.game.id ||
    prevProps.game.game_status !== nextProps.game.game_status ||
    prevProps.game.clock !== nextProps.game.clock ||
    prevProps.game.period !== nextProps.game.period ||
    prevProps.game.home_score !== nextProps.game.home_score ||
    prevProps.game.away_score !== nextProps.game.away_score ||
    prevProps.game.situation !== nextProps.game.situation ||
    prevProps.game.last_play !== nextProps.game.last_play ||
    prevProps.game.possession !== nextProps.game.possession;

  // Only prevent re-render if nothing has changed
  return (
    !gameChanged &&
    prevProps.displayedWeek === nextProps.displayedWeek &&
    prevProps.className === nextProps.className &&
    JSON.stringify(prevProps.userPick) === JSON.stringify(nextProps.userPick) &&
    JSON.stringify(prevProps.watchedPicks) === JSON.stringify(nextProps.watchedPicks) &&
    prevProps.isBetSlipOpen === nextProps.isBetSlipOpen
  );
});

GameCard.propTypes = {
  game: PropTypes.shape({
    id: PropTypes.number.isRequired,
    game_status: PropTypes.string.isRequired,
    // ... other game props
  }).isRequired,
  userPick: PropTypes.object,
  displayedWeek: PropTypes.number.isRequired,
  watchedPicks: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    weekNumber: PropTypes.number.isRequired
  })).isRequired,
  isBetSlipOpen: PropTypes.bool.isRequired,
  className: PropTypes.string,
};

export default GameCard;
